import type { TypedDocumentNode } from "@apollo/client";
import gql from "graphql-tag";

export type CountriesFilterQueryVariables = {
  page?: number
  limit?: number
  isActive?: boolean
};

export type CountriesFilterQuery = {
  getCountries: {
    data: Array<{
      id: string
      name: string
      locale: string
    }>
  }
};

export const COUNTRIES_FILTER_QUERY: TypedDocumentNode<CountriesFilterQuery, CountriesFilterQueryVariables> = gql`
  query countries($page: Int, $limit: Int, $isActive: Boolean) {
    getCountries(page: $page, limit: $limit, isActive: $isActive) {
      data {
        id
        name
        locale
      }
    }
  }
`;
